<template>
    <div class="keystone-market-research-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Home Improvement Market Research
                </div>
                <div class="logo">
                    <img src="/images/powered-by-logo-keystone.png">
                </div>
            </div>
          <div class="highlight-bar">
            <h1>Use password EpwinConnect to access the downloads</h1>
          </div>
          <h1 class="keystone-title">
              Consumer Fenestration Trends Report, Sponsored by Epwin Window Systems
            </h1>
            <div class="box-1">
              <div class="technical-uploads-list" v-show="keystone_marketing_downloads.length > 0">
                <div class="technical-uploads-list-item" v-for="keystone_marketing_download in keystone_marketing_downloads">
                  <div class="box _bordered">
                    <div>
                      <img :src="`${$aws_bucket_url}${keystone_marketing_download.thumbnail_url}`" @error="imageFallbackIcon">
                    </div>
                    <div>
                      <div class="technical-uploads-list-item-name"> {{ keystone_marketing_download.name }} </div>
                      <div class="pt-2">
                        <a class="btn-primary _sm" @click.stop.prevent="downloadItem(keystone_marketing_download.id)">
                          <strong>Download</strong>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-2">
              <p>
                Keystone Market Research, a research consultancy specialising in fenestration, has launched a new quarterly digital report designed to deliver ongoing essential consumer insights for businesses in the UK fenestration industry.
              </p>
              <p>
                The first edition explores a wide-ranging selection of topics, including consumer preferences on window, door, and extension roof glazing styles, frame materials, smart home technology compatibility and purchase priorities, as well as likelihood of purchase of fenestration products versus competing home improvement projects like kitchen and bathroom remodels. Additionally, it provides critical information to inform marketing decisions, including consumer-friendly product terms and the sources homeowners turn to for information on available products, providing actionable insights for fenestration businesses.
              </p>
              <div>
                <a class="btn-primary _lg" @click.prevent="enquiry_box_open = true">
                  Make Enquiry
                </a>
              </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Keystone Market Research Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like further information on the Consumer Fenestration Trends Report',
          sending: false,
          keystone_marketing_downloads: [],
          loading: true,
        }
    },
    async mounted() {
      this.loadKeystoneDownloads();
    },
    methods: {
        loadKeystoneDownloads: _.debounce(function() {
          this.loading = true;
          axios.post('/keystone-downloads/loadKeystoneDownloads').then((response) => {
            this.keystone_marketing_downloads = response.data;
            this.loading = false;
          });
        }, 250),
        downloadItem(item_id) {
          this.file_box_open = false;
          this.open_file = {};
          axios.get( `/keystone-downloads/download-item/${item_id}`).then((response) => {
            window.location.href = response.data;
          });
        },
        imageFallbackIcon(event) {
          event.target.src = '/images/content-uploads-thumbnail-fallback-icon.png';
        },
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 48,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Keystone Market Research enquiry',
                'value': 'Keystone Market Research enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
        partnerLinkClicked() {
            axios.post('/activity-logs/createActivityLogFromRequest', {
                'activity_log_category_id': 3,
                'description': `Partner Link Clicked - Keystone Market Research`,
            });
            gtag('event', 'partner_link_clicked', {
                'event_category': 'link',
                'event_label': 'Keystone Market Research partner link clicked',
                'value': 'Keystone Market Research partner link clicked',
            });
        },
    },
};
</script>
